module.exports = __webpack_public_path__ + "img/10.1cc46802.png";